import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CnaeRegra {
  codigo: number;
  datRegistro: string;
  numAplicaMei: number;
  numAtiva: number;
  numBaixaTse: number;
  numDelegacia: number;
  numDocContribuinte: number;
  numGeraIcms: number;
  numRisco: number;
  numSedeOutraUf: number;
  numVistoria: number;
  vlrCapitalFinal?: number;
  vlrCapitalInicial?: number;
}

export interface Cnae {
  cnaeRegra: CnaeRegra;
  codCnae: string;
  dscCnae: string;
}

export interface CnaeContribuinte {
  cnae: Cnae;
  datRegistro: string;
  datFim?: string;
  id: number;
  numExerceNoEnd: number;
  numPrincipal: number;
}

export interface Cep {
  cidade: {
    dscCidade: string;
    estado: {
      codigo: string;
      dscUf: string;
    };
  };
  codCep: string;
  dscBairro: string;
  dscComplemento: string;
  dscLogradouro: string;
}

export interface Endereco {
  cep: Cep;
  codigo: number;
  dscBairro: string;
  dscComplemento: string;
  dscLogradouro: string;
  dscNumero: string;
  naturezaImovel: {
    codigo: number;
    dscNaturezaImovel: string;
  };
  pais: {
    codigo: number;
    dscPais: string;
    dscSiglaPais: string;
  };
  tipoComplemento?: {
    codigo: number;
    dscTipoComplemento: string;
  };
}

export interface EnderecoEstabelecimento {
  codigo: number;
  dtInicio: string;
  endereco: Endereco;
  seqContribuinte: number;
  tipoEndereco: {
    codigo: number;
    dscTipoEndereco: string;
  };
}

export interface ConsultaIEResponse {
  cnaePrincipal: CnaeContribuinte[];
  cnaesSecundarios: CnaeContribuinte[];
  cpfCnpj: string;
  dataSituacaoCpfCnpj: string;
  dataSituacaoInscricaoEstadual: string;
  dscCategoriaEstabelecimento: string;
  dscInscricaoEstadual: string;
  dscRazaoSocial: string;
  enderecoEstabelecimento: EnderecoEstabelecimento;
  situacaoCpfCnpj: string;
  situacaoInscricaoEstadual: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConsultaPublicaService {

  private apiUrl = environment.API_URL;

  constructor(private http: HttpClient) { }

  consultarPorCpfCnpj(cpfCnpj: string): Observable<ConsultaIEResponse> {
    return this.http.get<ConsultaIEResponse>(`${this.apiUrl}/contribuinte/consulta/cpfCnpj/${cpfCnpj}`);
  }

  consultarPorIE(inscricaoEstadual: string): Observable<ConsultaIEResponse> {
    return this.http.get<ConsultaIEResponse>(`${this.apiUrl}/contribuinte/consulta/ie/${inscricaoEstadual}`);
  }

  consultarPDF(dscIe: string): Observable<{ arquivo: string; nomeArquivo: string }> {
    return this.http.get<{ arquivo: string; nomeArquivo: string }>(`${this.apiUrl}/contribuinte/consulta/ie/${dscIe}/pdf`);
  }

  consultarListaIe(cpfCnpj: string): Observable<any> {
    return this.http.get<ConsultaIEResponse[]>(`${this.apiUrl}/contribuinte/listarContribuintePorIe/${cpfCnpj}`);
  }
}
